import http from "@/http/aisea/axios";
const resource = "/enterprise/addon";

export default {
  // 法人アドオン一覧取得
  fetchAddons() {
    return http.get(`${resource}`);
  },

  //法人アドオン - 外部APIアクセストークン取得
  fetchExternalToken(enterpriseAddonId) {
    return http.get(`${resource}/${enterpriseAddonId}/tokens`);
  },
};
